import storage from 'store2';

import { SET_FRIENDS_AND_FAMILY_STATE } from './actions';
import { PROP_FRIENDS_AND_FAMILY, TOGGLE } from './constants';
import { CLEAR_STORE } from '../shared/actions';

const initialState = {
	[PROP_FRIENDS_AND_FAMILY]: !!storage.local.get(PROP_FRIENDS_AND_FAMILY),
};

function miscReducer(state = initialState, { type, payload }) {
	// eslint-disable-next-line sonarjs/no-small-switch
	switch (type) {
		default:
			return state;
		case SET_FRIENDS_AND_FAMILY_STATE:
			if (process.env.NODE_ENV === 'development') {
				console.assert(
					typeof payload.newState === 'boolean' || payload.newState === TOGGLE,
					`Action "${SET_FRIENDS_AND_FAMILY_STATE}" called with invalid payload: ${payload}`
				);
			}

			if (payload.newState === TOGGLE) {
				return {
					...state,
					[PROP_FRIENDS_AND_FAMILY]: !state[PROP_FRIENDS_AND_FAMILY],
				};
			}

			return {
				...state,
				[PROP_FRIENDS_AND_FAMILY]: payload.newState,
			};

		case CLEAR_STORE:
			return initialState;
	}
}

export default miscReducer;
